// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./icons/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/fonts/Oswald/Oswald-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/fonts/Raleway/Raleway-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/fonts/Raleway/Raleway-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/fonts/Lora/Lora-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/fonts/Lora/Lora-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../public/fonts/Montserrat/Montserrat-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../public/fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../public/fonts/Nunito/Nunito-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../public/fonts/Nunito/Nunito-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../public/fonts/Roboto/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../public/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../public/fonts/Roboto/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../../public/fonts/Roboto/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../../public/fonts/Merriweather/Merriweather-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../../public/fonts/Merriweather/Merriweather-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../../public/fonts/Merriweather/Merriweather-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../../public/fonts/Merriweather/Merriweather-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../../public/fonts/Spectral/Spectral-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../../public/fonts/Spectral/Spectral-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../../public/fonts/Spectral/Spectral-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../../public/fonts/Spectral/Spectral-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 300;
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 700;
}
@font-face {
  font-family: "Oswald";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Lora";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Lora";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Montserrat";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-weight: 100 900;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-weight: 300;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-weight: 800;
}
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: 300;
}
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-weight: 700;
}
@font-face {
  font-family: "Merriweather";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  font-weight: 300;
}
@font-face {
  font-family: "Merriweather";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  font-weight: 700;
}
@font-face {
  font-family: "Merriweather";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  font-weight: 300;
}
@font-face {
  font-family: "Merriweather";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  font-weight: 700;
}
@font-face {
  font-family: "Spectral";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  font-weight: 300;
}
@font-face {
  font-family: "Spectral";
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  font-weight: 700;
}
@font-face {
  font-family: "Spectral";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  font-weight: 300;
}
@font-face {
  font-family: "Spectral";
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  font-weight: 700;
}
/* Fonts */
.fs-60 {
  font-size: 60px;
}

.fs-40 {
  font-size: 40px;
}

.fs-36 {
  font-size: 36px;
}

.fs-32 {
  font-size: 32px;
}

.fs-30 {
  font-size: 30px;
}

.fs-24 {
  font-size: 24px;
}

.fs-20 {
  font-size: 20px;
}

.fs-28 {
  font-size: 28px;
}

.fs-18 {
  font-size: 18px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-12 {
  font-size: 12px;
}

.fs-10 {
  font-size: 10px;
}

body {
  font-family: "Poppins", sans-serif;
  color: rgba(39, 30, 75, 0.8);
  background-color: #fafafa;
  font-size: 14px;
  font-weight: normal;
}

#app-container {
  padding: 0;
  overflow-x: hidden;
}

#content-container {
  padding-bottom: 1rem;
  height: 100vh;
  overflow-y: scroll;
}

.page-header {
  border-radius: 4px;
  padding-top: 1rem;
}
.page-header .action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.page-header .action .btn:hover {
  background-color: transparent;
  color: #1D1D1B;
}

.badge {
  font-weight: 300;
}

.data-leads {
  padding: 0.4rem;
}

#datepicker {
  min-width: 320px;
  border: 1px solid #cecece;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
}
#datepicker span {
  font-size: 1rem;
}

.nav-pills .nav-link.active {
  background-color: #092776;
}

pre {
  background-color: rgba(0, 0, 0, 0.7019607843);
  color: white;
  padding: 16px;
  border-radius: 4px;
}

#auth-lp {
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  background-size: cover;
}
#auth-lp .row {
  height: 100%;
}
#auth-lp img {
  max-width: 300px;
}
#auth-lp a {
  text-decoration: none;
}
#auth-lp .auth-card {
  border: none;
  border-radius: 60px;
  padding: 50px;
}
#auth-lp .auth-card h2 {
  text-align: center;
  font-size: 20px;
  margin: 20px 0 16px;
  color: black;
}
#auth-lp .auth-card .logo {
  height: 45px;
  margin-bottom: 14px;
}
#auth-lp .auth-card .card-header {
  text-align: center;
  font-size: 30px;
  background-color: transparent;
  border: none;
  padding: 1rem;
}
#auth-lp .auth-card label {
  color: black;
  font-weight: 500;
  background-color: white;
  padding: 0 8px;
  transform: translate(10px, 10px);
}
#auth-lp .auth-card .form-control {
  border-radius: 0;
  border-color: #092776;
  padding: 12px 16px;
}
#auth-lp .auth-card .form-control::placeholder {
  color: #A3A3A3;
}
#auth-lp .auth-card .btn {
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 0;
  margin-top: 24px;
}

#app-navigation {
  background-color: #092776;
  height: 100%;
}
#app-navigation #app-logo {
  margin-top: 1rem;
}
#app-navigation .accordion {
  margin-top: 3rem;
}
#app-navigation .accordion-body {
  padding: 0;
}
#app-navigation a {
  text-decoration: none;
}
#app-navigation img {
  max-width: 200px;
}
#app-navigation .accordion-item {
  background-color: transparent;
  border: none;
}
#app-navigation .accordion-header .accordion-button.collapsed {
  background-color: transparent;
  color: white;
}
#app-navigation .accordion-header .accordion-button {
  background-color: rgba(0, 0, 0, 0.7921568627);
  border-radius: 0;
  color: white;
}
#app-navigation .accordion-header .accordion-button {
  font-size: 0.8rem;
}
#app-navigation .accordion-header .accordion-button .bi {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}
#app-navigation .accordion-header button::after {
  filter: invert(100%) sepia(0%) saturate(7%) hue-rotate(189deg) brightness(102%) contrast(100%);
}
#app-navigation .accordion-header button:focus {
  box-shadow: none;
}
#app-navigation .accordion-body {
  background-color: rgba(0, 0, 0, 0.0823529412);
}
#app-navigation .menu-item a {
  text-decoration: none;
  color: white;
  display: flex;
  align-items: center;
  padding-left: 2.5rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  box-shadow: none;
  transition: all 0.2s ease-in-out;
  font-size: 0.75rem;
}
#app-navigation .menu-item a:hover {
  background-color: rgba(0, 0, 0, 0.6862745098);
}
#app-navigation .menu-item .bi {
  font-size: 1.3rem;
  margin-right: 0.5rem;
}
#app-navigation #nav-footer button {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  border-radius: 0;
  font-size: 0.7rem;
}
#app-navigation a.active {
  background-color: rgba(0, 0, 0, 0.4588235294);
  border: none;
}
#app-navigation .btn-new-app {
  background-color: transparent;
  border: 1px solid gray;
  color: white;
}
#app-navigation .btn-new-app:hover {
  background-color: white;
  color: #092776;
  border: 1px solid white;
}

.genelead-table {
  background-color: white;
}
.genelead-table th {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 1rem;
  padding: 0.5rem 0.25rem !important;
  background-color: #092776;
  color: white;
  text-align: center;
}
.genelead-table th, .genelead-table td {
  vertical-align: middle;
}
.genelead-table .badge {
  font-weight: 400;
}
.genelead-table th .bi {
  display: none;
}

.genelead-card .card-header {
  background-color: #092776;
  color: white;
  font-size: 0.9rem;
}

.category-theme {
  color: white;
  padding: 0.5rem;
  border-radius: 4px;
}

.site-domain-card {
  max-width: 300px;
}
.site-domain-card .card-header {
  font-size: 18px;
  background-color: #092776;
  color: white;
}

.database-button {
  border: 1px solid #cecece;
  padding: 0.3rem;
  border-radius: 4px;
}
.database-button small {
  word-wrap: break-word;
}
.database-button .btn-navlink {
  padding: 0.25rem 0.5rem;
}

.reporting-table tbody {
  border-top: 1px solid black !important;
}
.reporting-table tbody td {
  vertical-align: middle;
  word-wrap: normal;
}
.reporting-table thead {
  width: 100%;
  vertical-align: middle;
  background-color: #092776 !important;
  position: sticky;
  top: 0;
}
.reporting-table .pictos th {
  text-align: center !important;
  background-color: #092776;
  font-weight: 300;
  color: white;
  padding: 0.7rem;
}
.reporting-table th a.sort-by {
  text-decoration: none;
  color: white;
  padding-right: 18px;
  position: relative;
  cursor: pointer;
}
.reporting-table a.sort-by:before,
.reporting-table a.sort-by:after {
  border: 4px solid transparent;
  content: "";
  display: block;
  height: 0;
  right: 5px;
  top: 50%;
  position: absolute;
  width: 0;
}
.reporting-table a.sort-by:before {
  border-bottom-color: white;
  margin-top: -9px;
}
.reporting-table a.sort-by:after {
  border-top-color: white;
  margin-top: 1px;
}

.btn-cancel {
  color: white;
}

.btn-lg, a.btn-lg {
  padding: 0.1rem 0.4rem;
}

.btn-icon {
  display: flex;
  align-items: center;
}
.btn-icon .btn-label {
  margin-left: 0.2em;
  font-size: 0.8em;
}

.btn-padding {
  padding: 0.5rem 1rem;
  padding-top: 0.5rem;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
}

.icon-placeholder-border:before {
  content: "\\e92e";
  font-size: 2.4rem;
}

.icon-label-border:before {
  content: "\\e931";
  font-size: 2.4rem;
}

.icon-placeholder-border-bottom:before {
  content: "\\e92f";
  font-size: 2.4rem;
}

.icon-label-border-bottom:before {
  content: "\\e930";
  font-size: 2.4rem;
}

.page-header .btn {
  padding: 0.25rem 0.5rem;
}
.page-header .btn .bi {
  font-size: 1.3rem;
}

.btn-secondary {
  background-color: #6c757d;
  color: white !important;
}

.btn-secondary:hover {
  color: white !important;
}

.btn-primary {
  background-color: #092776;
  border-color: #092776;
}

.page-item.active .page-link {
  background-color: #092776 !important;
  border-color: #092776 !important;
}

.btn-primary:hover {
  color: white;
}

.btn-navlink {
  color: white;
}

.alt-primary {
  background-color: transparent !important;
  color: #092776 !important;
  border-color: #092776;
  border: 1px solid #092776;
}

.alt-primary:hover {
  background-color: #092776 !important;
  color: white !important;
}

.alt-primary:focus {
  color: #092776 !important;
}

.alt-secondary {
  background-color: transparent !important;
  color: #6c757d !important;
  border-color: #6c757d;
  border: 1px solid #cecece;
}

.alt-secondary:hover {
  background-color: #6c757d !important;
  color: white !important;
}

.alt-danger {
  background-color: transparent !important;
  color: red;
  border-color: red;
  border: 1px solid;
}

.alt-success {
  background-color: transparent !important;
  color: green;
  border-color: green;
  border: 1px solid;
}

.alt-success:hover {
  color: green !important;
}

.captain-verify-phone-span {
  border: 1px solid #1D1D1B;
  border-radius: 4px;
  padding: 0.5rem;
  display: block;
  margin-right: 0.3rem;
}

.col-pick-img {
  position: relative;
}
.col-pick-img .pick-image {
  position: absolute;
  top: 0;
}

.form-field-badge {
  font-size: 1.1em;
  font-weight: 300;
  border: 1px solid #cecece;
}

.account-tabs .tab-pane {
  padding: 1rem !important;
  background-color: white;
  border: 1px solid #f1f1f1;
}

.tabs-landing .tab-pane {
  padding: 1.5rem 3rem;
  background-color: white;
  border: 1px solid #f0f0f0;
}

.preview-editor {
  border: 1px solid #cecece;
  border-radius: 4px;
  cursor: text;
}

.field-choice-legend {
  border: 1px solid #CECECE;
  border-radius: 6px;
  padding: 0.7rem;
}

.company-account-item.active a {
  color: white !important;
}

.btn-edit-editor {
  position: absolute;
  left: 2rem;
  background-color: rgba(7, 39, 99, 0.7);
  border-radius: 4px;
}

.btn-edit-editor:hover {
  background-color: #092776;
}

label input:checked + .d-flex {
  color: #ffffff;
  background-color: #000000;
  border: 1px solid #000000;
}

.date-picker {
  min-width: 350px;
}
.date-picker .date-picker-wrapper {
  color: #1D1D1B;
  background-color: transparent;
  border-radius: 4px;
}

.lead-statutes {
  display: flex;
  justify-content: end;
  margin: 0;
  padding: 0;
}
.lead-statutes li button {
  width: 100%;
  padding: 0.8rem;
}
.lead-statutes li .active {
  background-color: #092776 !important;
  color: white !important;
}

.page-header .form-floating.form-control {
  padding: 0;
}

.option-wrapper {
  display: flex;
  width: 100%;
  border: 1px solid rgba(26, 118, 255, 0.0901960784);
  background-color: rgba(26, 118, 255, 0.0901960784);
  align-items: center;
  padding: 0.5rem;
  margin-top: 0.2rem;
}
.option-wrapper .form-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  cursor: pointer;
}
.option-wrapper small {
  font-size: 0.6rem;
}

.filters {
  color: #1D1D1B;
}
.filters .form-control, .filters .form-select {
  background-color: white;
  color: #1D1D1B;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/fonts.scss","webpack://./src/assets/scss/app-design.scss","webpack://./src/assets/scss/auth.scss","webpack://./src/assets/scss/navigation.scss","webpack://./src/assets/scss/table.scss","webpack://./src/assets/scss/buttons.scss","webpack://./src/assets/scss/forms.scss","webpack://./src/assets/scss/filters.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;ACEJ;ADCA;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;ACCJ;ADEA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACAJ;ADGA;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACDJ;ADIA;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACFJ;ADKA;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACHJ;ADMA;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACJJ;ADOA;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACLJ;ADQA;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACNJ;ADSA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,oBAAA;ACPJ;ADUA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,oBAAA;ACRJ;ADWA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACTJ;ADYA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACVJ;ADaA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACXJ;ADcA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACZJ;ADeA;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACbJ;ADgBA;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACdJ;ADiBA;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACfJ;ADkBE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;AChBJ;ADmBE;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACjBJ;ADoBE;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;AClBJ;ADoBE;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;AClBJ;ADqBE;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;ACnBJ;AA9JA,UAAA;AAcA;EAAO,eAAA;AAoJP;;AAnJA;EAAO,eAdC;AAqKR;;AAtJA;EAAO,eAdC;AAwKR;;AAzJA;EAAO,eAdC;AA2KR;;AA5JA;EAAO,eAdC;AA8KR;;AA/JA;EAAO,eAbC;AAgLR;;AAlKA;EAAO,eAbC;AAmLR;;AArKA;EAAO,eAhBC;AAyLR;;AAxKA;EAAO,eAdC;AA0LR;;AA3KA;EAAO,eAdC;AA6LR;;AA9KA;EAAO,eAdC;AAgMR;;AAjLA;EAAO,eAdC;AAmMR;;AApLA;EAAO,eAdC;AAsMR;;AAvLA;EAAO,eAdC;AAyMR;;AAvKA;EACI,kCAAA;EACA,4BAjBS;EAkBT,yBApBM;EAqBN,eAAA;EACA,mBAAA;AA0KJ;;AAvKA;EACI,UAAA;EACA,kBAAA;AA0KJ;;AAvKA;EACI,oBAAA;EACA,aAAA;EACA,kBAAA;AA0KJ;;AAvKA;EAEI,kBAAA;EACA,iBAAA;AAyKJ;AAvKI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AAyKR;AAvKQ;EACI,6BAAA;EACA,cA/CC;AAwNb;;AApKA;EACI,gBAAA;AAuKJ;;AApKA;EACI,eAAA;AAuKJ;;AApKA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAuKJ;AArKI;EACI,eAAA;AAuKR;;AAnKA;EACI,yBAvEQ;AA6OZ;;AAnKA;EACE,6CAnEI;EAoEJ,YAAA;EACA,aAAA;EACA,kBAAA;AAsKF;;ACxRA;EACE,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;AD2RF;ACzRE;EACE,YAAA;AD2RJ;ACxRE;EACE,gBAAA;AD0RJ;ACvRE;EACE,qBAAA;ADyRJ;ACtRE;EACE,YAAA;EACA,mBAAA;EACA,aAAA;ADwRJ;ACtRI;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACC,YAAA;ADwRP;ACrRI;EACE,YAAA;EACA,mBAAA;ADuRN;ACpRI;EACE,kBAAA;EACA,eD9BE;EC+BF,6BAAA;EACA,YAAA;EACA,aAAA;ADsRN;ACnRI;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;ADqRN;AClRI;EACE,gBAAA;EACA,qBDjBM;ECkBN,kBAAA;ADoRN;AClRM;EACE,cAAA;ADoRR;AChRI;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;ADkRN;;AEpVA;EACI,yBFmCQ;EElCR,YAAA;AFuVJ;AErVI;EACI,gBAAA;AFuVR;AEpVI;EACI,gBAAA;AFsVR;AEnVI;EACI,UAAA;AFqVR;AElVI;EACI,qBAAA;AFoVR;AEjVI;EACI,gBAAA;AFmVR;AEhVI;EACI,6BAAA;EACA,YAAA;AFkVR;AE9UQ;EACI,6BAAA;EACA,YAAA;AFgVZ;AE7UQ;EACI,6CFUC;EETD,gBAAA;EAEA,YAAA;AF8UZ;AE3UQ;EACI,iBAAA;AF6UZ;AE3UY;EACI,iBAAA;EACA,oBAAA;AF6UhB;AEzUQ;EACI,8FAAA;AF2UZ;AExUQ;EACI,gBAAA;AF0UZ;AEtUI;EACI,6CAAA;AFwUR;AEpUQ;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AFqUZ;AElUQ;EACI,6CFjCC;AAqWb;AEjUQ;EACI,iBAAA;EACA,oBAAA;AFmUZ;AE/TI;EACI,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AFiUR;AE9TI;EACI,6CFnDM;EEoDN,YAAA;AFgUR;AE7TI;EACI,6BAAA;EACA,sBAAA;EACA,YAAA;AF+TR;AE7TQ;EACI,uBAAA;EACA,cF1EA;EE2EA,uBAAA;AF+TZ;;AG9aA;EACE,uBAAA;AHibF;AG3aE;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBHwBQ;EGvBR,YAAA;EACA,kBAAA;AH6aJ;AG1aE;EACE,sBAAA;AH4aJ;AGzaE;EACE,gBAAA;AH2aJ;AGxaE;EACE,aAAA;AH0aJ;;AGraE;EACE,yBHIQ;EGHR,YAAA;EACA,iBAAA;AHwaJ;;AGpaA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AHuaF;;AGpaA;EACE,gBAAA;AHuaF;AGraE;EACE,eAAA;EACA,yBHbQ;EGcR,YAAA;AHuaJ;;AGnaA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AHsaF;AGpaE;EACE,qBAAA;AHsaJ;AGnaE;EACE,uBAAA;AHqaJ;;AGhaE;EACE,sCAAA;AHmaJ;AGhaE;EACE,sBAAA;EACA,iBAAA;AHkaJ;AG/ZE;EACE,WAAA;EACA,sBAAA;EACA,oCAAA;EAEA,gBAAA;EACA,MAAA;AHiaJ;AG7ZI;EACE,6BAAA;EACA,yBHtDM;EGuDN,gBAAA;EACA,YAAA;EACA,eAAA;AH+ZN;AG3ZE;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AH6ZJ;AG1ZE;;EAEE,6BAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;AH4ZJ;AGzZE;EACE,0BAAA;EACA,gBAAA;AH2ZJ;AGxZE;EACE,uBAAA;EACA,eAAA;AH0ZJ;;AIthBA;EACI,YAAA;AJyhBJ;;AIthBA;EACI,sBAAA;AJyhBJ;;AIrhBA;EACI,aAAA;EACA,mBAAA;AJwhBJ;AIthBI;EACI,kBAAA;EACA,gBAAA;AJwhBR;;AIphBA;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AJuhBJ;;AIphBA;EACI,gBAAA;EACA,iBAAA;AJuhBJ;;AIphBA;EACI,gBAAA;EACA,iBAAA;AJuhBJ;;AIphBA;EACI,gBAAA;EACA,iBAAA;AJuhBJ;;AIphBE;EACE,gBAAA;EACA,iBAAA;AJuhBJ;;AIphBA;EACI,uBAAA;AJuhBJ;AIrhBI;EACI,iBAAA;AJuhBR;;AIlhBA;EACI,yBJpBc;EIqBd,uBAAA;AJqhBJ;;AIlhBA;EACI,uBAAA;AJqhBJ;;AIlhBA;EACI,yBJ9BQ;EI+BR,qBJ/BQ;AAojBZ;;AIlhBA;EACI,oCAAA;EACA,gCAAA;AJqhBJ;;AIlhBA;EACI,YAAA;AJqhBJ;;AIjhBA;EACI,YAAA;AJohBJ;;AIjhBA;EACI,wCAAA;EACA,yBAAA;EACA,qBJnDQ;EIoDR,yBAAA;AJohBJ;;AIlhBA;EACI,oCAAA;EACA,uBAAA;AJqhBJ;;AInhBA;EACI,yBAAA;AJshBJ;;AInhBA;EACI,wCAAA;EACA,yBAAA;EACA,qBJhEc;EIiEd,yBAAA;AJshBJ;;AInhBA;EACI,oCAAA;EACA,uBAAA;AJshBJ;;AInhBA;EACI,wCAAA;EACA,UJvEU;EIwEV,iBJxEU;EIyEV,iBAAA;AJshBJ;;AInhBA;EACI,wCAAA;EACA,YJ7EW;EI8EX,mBJ9EW;EI+EX,iBAAA;AJshBJ;;AInhBA;EACI,uBAAA;AJshBJ;;AKnpBA;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;ALspBJ;;AKnpBA;EACI,kBAAA;ALspBJ;AKrpBI;EACI,kBAAA;EACA,MAAA;ALupBR;;AKnpBA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;ALspBJ;;AKnpBA;EACI,wBAAA;EACA,uBAAA;EACA,yBAAA;ALspBJ;;AKlpBI;EACI,oBAAA;EACA,uBAAA;EACA,yBAAA;ALqpBR;;AKjpBA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;ALopBJ;;AKhpBA;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;ALmpBJ;;AK/oBI;EACI,uBAAA;ALkpBR;;AK7oBA;EACI,kBAAA;EACA,UAAA;EACA,sCAAA;EACA,kBAAA;ALgpBJ;;AK7oBA;EACI,yBL5BQ;AA4qBZ;;AK7oBA;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;ALgpBJ;;AMntBA;EACI,gBAAA;ANstBJ;AMrtBI;EACI,cN4BK;EM3BL,6BAPY;EAQZ,kBAAA;ANutBR;;AMntBA;EACI,aAAA;EACJ,oBAAA;EACE,SAAA;EACA,UAAA;ANstBF;AMntBM;EACE,WAAA;EACA,eAAA;ANqtBR;AMltBM;EACI,oCAAA;EACA,uBAAA;ANotBV;;AM9sBI;EACI,UAAA;ANitBR;;AM7sBA;EACI,aAAA;EACA,WAAA;EACA,kDAAA;EACA,kDNDS;EMET,mBAAA;EACA,eAAA;EACA,kBAAA;ANgtBJ;AM9sBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;ANgtBR;AM7sBI;EACI,iBAAA;AN+sBR;;AM3sBA;EACI,cN1BS;AAwuBb;AM5sBI;EACI,uBAAA;EACA,cN9BK;AA4uBb","sourcesContent":["@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Poppins/Poppins-Regular.ttf');\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Poppins/Poppins-Bold.ttf');\n    font-weight: 700;\n}\n\n@font-face {\n    font-family: 'Oswald';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Oswald/Oswald-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Raleway';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Raleway/Raleway-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Raleway';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Raleway/Raleway-Italic-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Lora';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Lora/Lora-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Lora';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Lora/Lora-Italic-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Montserrat';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Montserrat/Montserrat-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Montserrat';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Nunito/Nunito-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Nunito/Nunito-Italic-VariableFont_wght.ttf');\n    font-weight: 100 900;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Roboto/Roboto-Thin.ttf');\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Roboto/Roboto-Bold.ttf');\n    font-weight: 800;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Roboto/Roboto-Italic.ttf');\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Roboto/Roboto-BoldItalic.ttf');\n    font-weight: 700;\n}\n\n@font-face {\n    font-family: 'Merriweather';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Merriweather/Merriweather-Regular.ttf');\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: 'Merriweather';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Merriweather/Merriweather-Bold.ttf');\n    font-weight: 700;\n}\n\n@font-face {\n    font-family: 'Merriweather';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Merriweather/Merriweather-Italic.ttf');\n    font-weight: 300;\n  }\n  \n  @font-face {\n    font-family: 'Merriweather';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Merriweather/Merriweather-BoldItalic.ttf');\n    font-weight: 700;\n  }\n  \n  @font-face {\n    font-family: 'Spectral';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Spectral/Spectral-Regular.ttf');\n    font-weight: 300;\n  }\n  \n  @font-face {\n    font-family: 'Spectral';\n    font-style: normal;\n    font-display: swap;\n    src: url('../../../public/fonts/Spectral/Spectral-Bold.ttf');\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: 'Spectral';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Spectral/Spectral-Italic.ttf');\n    font-weight: 300;\n  }\n  \n  @font-face {\n    font-family: 'Spectral';\n    font-style: italic;\n    font-display: swap;\n    src: url('../../../public/fonts/Spectral/Spectral-BoldItalic.ttf');\n    font-weight: 700;\n  }","@import './icons/style.css';\n@import './fonts.scss';\n\n/* Fonts */\n$fs-40: 40px;\n$fs-36: 36px;\n$fs-32: 32px;\n$fs-30: 30px;\n$fs-28: 28px;\n$fs-24: 24px;\n$fs-20: 20px;\n$fs-18: 18px;\n$fs-16: 16px;\n$fs-15: 15px;\n$fs-14: 14px;\n$fs-12: 12px;\n$fs-10: 10px;\n.fs-60{font-size: 60px;}\n.fs-40{font-size: $fs-40;}\n.fs-36{font-size: $fs-36;}\n.fs-32{font-size: $fs-32;}\n.fs-30{font-size: $fs-30;}\n.fs-24{font-size: $fs-24;}\n.fs-20{font-size: $fs-20;}\n.fs-28{font-size: $fs-28;}\n.fs-18{font-size: $fs-18;}\n.fs-16{font-size: $fs-16;}\n.fs-15{font-size: $fs-15;}\n.fs-14{font-size: $fs-14;}\n.fs-12{font-size: $fs-12;}\n.fs-10{font-size: $fs-10;}\n\n$genelead: #1d4eaf;\n$bg-main: #fafafa;\n$main-color: #1D1D1B;\n$body-color: #271E4BCC;\n$main-blue: #092776;\n$main-secondary:  #6c757d;\n$main-warning: #ffc107;\n$main-info: #0dcaf0;\n$main-hover: #1a76ff17;\n$main-danger: red;\n$main-success: green;\n$text-color: #C0D3FC;\n$pre: #000000b3;\n\n$menu-focus: #000000ca;\n$menu-hover: #000000af;\n$menu-active: #00000075;\n\nbody {\n    font-family: 'Poppins', sans-serif;\n    color: $body-color;\n    background-color: $bg-main;\n    font-size: 14px;\n    font-weight:normal;\n}\n\n#app-container {\n    padding:0;\n    overflow-x: hidden;\n}\n\n#content-container {\n    padding-bottom:1rem;\n    height:100vh;\n    overflow-y: scroll;\n}\n\n.page-header {\n    //padding:0.5rem;\n    border-radius:4px;\n    padding-top:1rem;\n\n    .action {\n        display:flex;\n        align-items: center;\n        justify-content: flex-end;\n    \n        .btn:hover {\n            background-color: transparent;\n            color:$main-color;\n        }\n    }\n}\n\n.badge {\n    font-weight: 300;\n}\n\n.data-leads {\n    padding:0.4rem;\n}\n\n#datepicker {\n    min-width: 320px;\n    border:1px solid #cecece;\n    border-radius:4px;\n    background-color: white;\n    cursor: pointer;\n    \n    span {\n        font-size:1rem;\n    }\n}\n\n.nav-pills .nav-link.active {\n    background-color:$main-blue;\n}\n\npre{\n  background-color: $pre;\n  color: white;\n  padding: 16px;\n  border-radius: 4px;\n}\n\n@import './auth.scss';\n@import './navigation.scss';\n@import './table.scss';\n@import './buttons.scss';\n@import './forms.scss';\n@import './filters.scss';","#auth-lp {\n  height:100vh;\n  background-image: url('../img/login.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  .row {\n    height:100%;\n  }\n\n  img {\n    max-width:300px;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  .auth-card {\n    border:none;\n    border-radius: 60px;\n    padding: 50px;\n\n    h2 {\n      text-align:center;\n      font-size: 20px;\n      margin: 20px 0 16px;\n       color: black;\n    }\n\n    .logo{\n      height: 45px;\n      margin-bottom: 14px;\n    }\n\n    .card-header {\n      text-align: center;\n      font-size:$fs-30;\n      background-color: transparent;\n      border:none;\n      padding:1rem;\n    }\n\n    label{\n      color: black;\n      font-weight: 500;\n      background-color: white;\n      padding: 0 8px;\n      transform: translate(10px, 10px);\n    }\n\n    .form-control{\n      border-radius: 0;\n      border-color: $main-blue;\n      padding: 12px 16px;\n\n      &::placeholder{\n        color: #A3A3A3;\n      }\n    }\n\n    .btn {\n      width:100%;\n      padding-top: 12px;\n      padding-bottom: 12px;\n      border-radius: 0;\n      margin-top: 24px;\n    }\n  }\n}","#app-navigation {\n    background-color: $main-blue;\n    height:100%;\n\n    #app-logo {\n        margin-top:1rem;\n    }\n\n    .accordion {\n        margin-top:3rem;\n    }\n\n    .accordion-body {\n        padding:0;  \n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    img {\n        max-width:200px;\n    }\n\n    .accordion-item {\n        background-color: transparent;\n        border:none;\n    }\n\n    .accordion-header {\n        .accordion-button.collapsed {\n            background-color: transparent;\n            color:white;\n        }\n\n        .accordion-button {\n            background-color: $menu-focus;\n            border-radius: 0;\n            //padding-right:0.7rem;\n            color:white;\n        }\n\n        .accordion-button {\n            font-size:0.8rem;\n\n            .bi {\n                font-size:1.5rem;\n                margin-right:0.5rem;\n            }\n        }\n\n        button::after {\n            filter: invert(100%) sepia(0%) saturate(7%) hue-rotate(189deg) brightness(102%) contrast(100%);\n        }\n\n        button:focus {\n            box-shadow: none;\n        }\n    }\n\n    .accordion-body {\n        background-color: #00000015;\n    }\n\n    .menu-item {\n        a {\n            text-decoration: none;\n            color:white;\n            display:flex;\n            align-items: center;\n            //padding:0.5rem 3rem;\n            padding-left: 2.5rem;\n            padding-top: 0.3rem;\n            padding-bottom:0.3rem;\n            box-shadow: none;\n            transition: all 0.2s ease-in-out;\n            font-size:0.75rem;\n        }\n\n        a:hover {\n            background-color: $menu-hover;\n        }\n\n        .bi {\n            font-size:1.3rem;\n            margin-right:0.5rem;\n        }\n    }\n\n    #nav-footer button {\n        width:100%;\n        text-align: left;\n        background-color: transparent;\n        border:none;\n        border-radius:0;\n        font-size:0.7rem;\n    }\n\n    a.active {\n        background-color: $menu-active;\n        border:none;\n    }\n\n    .btn-new-app {\n        background-color: transparent;\n        border:1px solid gray;\n        color:white;\n\n        &:hover{\n            background-color: white;\n            color: $main-blue;\n            border:1px solid white;\n        }\n    }\n}\n",".genelead-table {\n  background-color: white;\n\n  tbody {\n    //border-top: none !important;\n  }\n\n  th {\n    text-transform: capitalize;\n    font-weight: 400;\n    font-size: 1rem;\n    padding: 0.5rem 0.25rem !important;\n    background-color: $main-blue;\n    color: white;\n    text-align: center;\n  }\n\n  th, td {\n    vertical-align: middle;\n  }\n\n  .badge {\n    font-weight: 400;\n  }\n\n  th .bi {\n    display: none;\n  }\n}\n\n.genelead-card {\n  .card-header {\n    background-color: $main-blue;\n    color: white;\n    font-size: 0.9rem;\n  }\n}\n\n.category-theme {\n  color: white;\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n.site-domain-card {\n  max-width: 300px;\n\n  .card-header {\n    font-size: 18px;\n    background-color: $main-blue;\n    color: white;\n  }\n}\n\n.database-button {\n  border: 1px solid #cecece;\n  padding: 0.3rem;\n  border-radius: 4px;\n\n  small {\n    word-wrap: break-word;\n  }\n\n  .btn-navlink {\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n.reporting-table {\n  tbody {\n    border-top:1px solid black !important;\n  }\n\n  tbody td {\n    vertical-align: middle;\n    word-wrap: normal;\n  }\n\n  thead {\n    width: 100%;\n    vertical-align: middle;\n    background-color: $main-blue !important;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n  }\n\n  .pictos {\n    th {\n      text-align: center !important;\n      background-color: $main-blue;\n      font-weight: 300;\n      color: white;\n      padding:0.7rem;\n    }\n  }\n\n  th a.sort-by {\n    text-decoration: none;\n    color: white;\n    padding-right: 18px;\n    position: relative;\n    cursor: pointer;\n  }\n\n  a.sort-by:before,\n  a.sort-by:after {\n    border: 4px solid transparent;\n    content: \"\";\n    display: block;\n    height: 0;\n    right: 5px;\n    top: 50%;\n    position: absolute;\n    width: 0;\n  }\n\n  a.sort-by:before {\n    border-bottom-color: white;\n    margin-top: -9px;\n  }\n\n  a.sort-by:after {\n    border-top-color: white;\n    margin-top: 1px;\n  }\n}",".btn-cancel {\n    color:white;\n}\n\n.btn-lg, a.btn-lg {\n    padding:0.1rem 0.4rem;\n    //display:inline;\n}\n\n.btn-icon {\n    display: flex;\n    align-items: center;\n\n    .btn-label {\n        margin-left:0.2em;\n        font-size:0.8em;\n    }\n}\n\n.btn-padding {\n    padding: 0.5rem 1rem;\n    padding-top: 0.5rem;\n    padding-right: 1rem;\n    padding-bottom: 0.5rem;\n    padding-left: 1rem;\n}\n\n.icon-placeholder-border:before {\n    content: \"\\e92e\";\n    font-size:2.4rem;\n}\n\n.icon-label-border:before {\n    content: \"\\e931\";\n    font-size:2.4rem;\n  }\n\n.icon-placeholder-border-bottom:before {\n    content: \"\\e92f\";\n    font-size:2.4rem;\n  }\n\n  .icon-label-border-bottom:before {\n    content: \"\\e930\";\n    font-size:2.4rem;\n  }\n\n.page-header .btn {\n    padding: 0.25rem 0.5rem;\n\n    .bi {\n        font-size:1.3rem;\n        //margin-right:0.3em;\n    }\n}\n\n.btn-secondary{\n    background-color: $main-secondary;\n    color:white !important;\n}\n\n.btn-secondary:hover {\n    color:white !important;\n}\n\n.btn-primary {\n    background-color: $main-blue;\n    border-color:$main-blue;\n}\n\n.page-item.active .page-link  {\n    background-color: $main-blue !important;\n    border-color:$main-blue !important;\n}\n\n.btn-primary:hover {\n    color:white;\n}\n\n\n.btn-navlink {\n    color:white;\n}\n\n.alt-primary {\n    background-color: transparent !important;\n    color: $main-blue !important;\n    border-color: $main-blue;\n    border:1px solid $main-blue;\n}\n.alt-primary:hover {\n    background-color: $main-blue !important;\n    color:white !important;\n}\n.alt-primary:focus {\n    color:$main-blue !important;\n}\n\n.alt-secondary {\n    background-color: transparent !important;\n    color: $main-secondary !important;\n    border-color: $main-secondary;\n    border:1px solid #cecece;\n}\n\n.alt-secondary:hover {\n    background-color: $main-secondary !important;\n    color: white !important;\n}\n\n.alt-danger {\n    background-color: transparent !important;\n    color:$main-danger;\n    border-color:$main-danger;\n    border: 1px solid;\n}\n\n.alt-success {\n    background-color: transparent !important;\n    color:$main-success;\n    border-color: $main-success;\n    border:1px solid;\n}\n\n.alt-success:hover {\n    color:$main-success !important;\n}",".captain-verify-phone-span {\n    border:1px solid $main-color;\n    border-radius:4px;\n    padding:0.5rem;\n    display:block;\n    margin-right:0.3rem;\n}\n\n.col-pick-img {\n    position:relative;\n    .pick-image {\n        position:absolute;\n        top:0;\n    }\n}\n\n.form-field-badge {\n    font-size:1.1em;\n    font-weight: 300;\n    border:1px solid #cecece;\n}\n\n.account-tabs .tab-pane {\n    padding:1rem !important;\n    background-color: white;\n    border:1px solid #f1f1f1;\n}\n\n.tabs-landing {\n    .tab-pane {\n        padding:1.5rem 3rem;\n        background-color: white;\n        border:1px solid #f0f0f0;\n    }\n}\n\n.preview-editor {\n    border:1px solid #cecece;\n    border-radius:4px;\n    cursor:text;\n    // padding:1rem;\n}\n\n.field-choice-legend {\n    border:1px solid #CECECE;\n    border-radius:6px;\n    padding:0.7rem;   \n}\n\n.company-account-item.active {\n    a {\n        color: white !important;\n    }\n    \n}\n\n.btn-edit-editor {\n    position:absolute;\n    left:2rem;\n    background-color: rgba(7, 39, 99, 0.7);\n    border-radius:4px;\n}\n\n.btn-edit-editor:hover {\n    background-color: $main-blue;\n}\n\nlabel input:checked+.d-flex {\n    color: #ffffff;\n    background-color: #000000;\n    border: 1px solid #000000;\n}","$filter-background: transparent;\n$filter-color: $main-blue;\n\n.date-picker {\n    min-width: 350px;\n    .date-picker-wrapper {\n        color:$main-color;\n        background-color: $filter-background;\n        border-radius:4px;\n    }\n}\n\n.lead-statutes {\n    display: flex;\njustify-content: end;\n  margin: 0;\n  padding: 0;\n\n  li {\n      button {\n        width:100%;\n        padding:0.8rem;\n      }\n\n      .active {\n          background-color: $main-blue !important;\n          color:white!important ;\n      }\n  }\n}\n\n.page-header {\n    .form-floating.form-control {\n        padding:0;\n    }\n}\n\n.option-wrapper {\n    display:flex;\n    width:100%;\n    border:1px solid $main-hover;\n    background-color: $main-hover;\n    align-items: center;\n    padding:0.5rem;\n    margin-top:0.2rem;\n\n    .form-label {\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        width:100%;\n        cursor:pointer;\n    }\n\n    small {\n        font-size:0.6rem;\n    }\n}\n\n.filters {\n    color:$main-color;\n\n    .form-control, .form-select {\n        background-color: white;\n        color:$main-color;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
